import { render, staticRenderFns } from "./UiModal.vue?vue&type=template&id=3990259a&scoped=true"
import script from "./UiModal.vue?vue&type=script&lang=js"
export * from "./UiModal.vue?vue&type=script&lang=js"
import style0 from "./UiModal.vue?vue&type=style&index=0&id=3990259a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3990259a",
  null
  
)

export default component.exports